<template>
<div class="common-search">
  <input type="text" :placeholder="$t('placeholder.search_store')" readonly="true" autocomplete="off" v-model="keyword" @click="onSearch">
  <div class="localtion" @click="goMap" v-if="showAddress">
    <div>{{ $t('address.address') }}</div>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'
import { AddressState } from '@src/const/address'

export default {
  name: 'HomeCommonSearch',
  props: {
    value: String,
    showAddress: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    value: function (value) {
      if (value) {
        this.keyword = value
      }
    }
  },
  computed: {
    ...mapState({
      isOnline: state => state.member.isOnline,  
    })
  },
  data () {
    return {
      keyword: this.value ? this.value : '' // 关键字
    }
  },
  methods: {
    onSearch () {
      this.$router.push({ name: 'HomeSearch', query: { category: this.$route.query.category, category_title: this.$route.query.category_title || '' }})
    },
    goMap () {
      if (this.isOnline) {
        this.$router.push({ name: 'MemberAddressList', 
        query : {
          o2o_errand_type: AddressState.PICKUP_POINT,
          from: 'member_profile'
        }})
      } else {
        this.$router.push({ name: 'HomeMap' })
      }      
    },
  }
}
</script>

<style scoped>
  .common-search{
    padding: 0.35rem 0.6rem;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .common-search input {
    box-sizing: border-box;
    border: 1px solid #E6E6e5;
    /* width: 100%; */
    width: 100%;
    height: 1.6rem;
    border-radius: 0.2rem;
    background: white url(../../../assets/image/home/icon_search.png) no-repeat 0.6rem center;
    background-size: 0.55rem;
    font-size: 0.7rem;
    color: #999;
    padding-left: 1.6rem;
    /* border: 0; */
	border-radius: 1rem;
  }
  .localtion {
    text-align: center;
    z-index: 2;
    white-space: nowrap;
    position: absolute;
    right: 3%;
    background: #f4c41e;
    padding: 6px 10px;
    border-radius: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .localtion div {
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    font-size:.7rem;
    font-weight: bold;
  }
</style>
